import { Id } from "./id";
import { ResourceTypes } from "./resourceTypes";

type CapacityPeriod = {
  from: string;
  to: string;
  capacity: number;
};

type ResourceCapacity = {
  uuid: Id;
  name: string;
  profession: string;
  type: ResourceTypes;
  avatarUrl: string;
  periods: CapacityPeriod[];
};

const capacityPeriod: CapacityPeriod = {
  from: "",
  to: "",
  capacity: 0,
};

const resourceCapacity: ResourceCapacity = {
  uuid: "",
  name: "",
  profession: "",
  type: ResourceTypes.HUMAN,
  avatarUrl: "",
  periods: [],
};

export type { CapacityPeriod, ResourceCapacity };

export { capacityPeriod, resourceCapacity };
